import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomerDropdown from "../../../components/Shared/CustomerDropdown";
import { Customer } from "../../../types/customer";

const BusinessProfileCard: React.FC = () => {
  const navigate = useNavigate();
  const [selectedCustomer, setSelectedCustomer] = useState<Customer | null>(
    null
  );

  const handleCustomerSelect = (customer: Customer | null) => {
    setSelectedCustomer(customer);
  };

  const handleContinueSetup = () => {
    if (selectedCustomer && selectedCustomer.customer_id) {
      navigate(`/business-profile/complete/${selectedCustomer.customer_id}`);
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 flex flex-col">
      <div className="p-6 flex-grow">
        <div className="flex items-center gap-4">
          <div
            className="p-3 rounded-full"
            style={{ backgroundColor: "#e4b372" }}
          >
            <span className="material-icons text-3xl text-[#2f4941]">
              palette
            </span>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">
              Finish Brand Details
            </h3>
            <p className="text-gray-600 mt-1">
              Use this section after the business profile is created to complete
              the details.
            </p>
          </div>
        </div>

        <div className="mt-6">
          <label
            className="block text-sm font-medium text-gray-600 mb-2"
            htmlFor="business-profile"
          >
            Select a Business Profile:
          </label>
          <div className="relative">
            <CustomerDropdown onCustomerSelect={handleCustomerSelect} />
          </div>
        </div>
      </div>

      <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
        <button
          className={`w-full font-semibold py-3 px-4 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2 ${
            !selectedCustomer
              ? "bg-surface-ui text-gray-500 cursor-not-allowed"
              : ""
          }`}
          style={
            selectedCustomer
              ? {
                  backgroundColor: "#e4b372",
                  color: "#2f4941",
                }
              : {}
          }
          onMouseEnter={
            selectedCustomer
              ? (e) => {
                  e.currentTarget.style.backgroundColor = "#d4a062";
                }
              : undefined
          }
          onMouseLeave={
            selectedCustomer
              ? (e) => {
                  e.currentTarget.style.backgroundColor = "#e4b372";
                }
              : undefined
          }
          disabled={!selectedCustomer}
          onClick={handleContinueSetup}
        >
          <span className="material-icons">check_circle_outline</span>
          Update Brand Details
        </button>
      </div>
    </div>
  );
};

export default BusinessProfileCard;
